import { APP_SETTINGS } from '@/common/config'
import axiosIns from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import SystemHelper from '@/common/systemHelper'

export const GET_PRODUCT_SUB_CATEGORIES = 'getProductSubCategories'
export const GET_PRODUCT_SUB_CATEGORY_BY_ID = 'getProductSubCategoryById'
export const CREATE_PRODUCT_SUB_CATEGORIES = 'createProductSubCategories'
export const UPDATE_PRODUCT_SUB_CATEGORIES = 'updateProductSubCategories'
export const DELETE_PRODUCT_SUB_CATEGORIES = 'deleteProductSubCategories'

export const SET_PRODUCT_SUB_CATEGORIES_LIST = 'setProductSubCategoriesList'
export const SET_PRODUCT_SUB_CATEGORY = 'setProductSubCategory'

export default {
  namespaced: true,
  state: {
    productSubCategoriesList: null,
    productSubCategory: null,
  },
  getters: {
    getPaginationInfo: state => {
      const list = state.productSubCategoriesList
      if (list) {
        return list
      }
      return []
    },
    activeProductSubCategoryList: state => {
      const currentState = state.productSubCategoriesList

      if (currentState) {
        const list = currentState.list.data

        if (Array.isArray(list) && list.length) {
          return list.filter(el => el.is_active)
        }
        return []
      }
      return []
    },

    getSelectedProductSubCategory: state => {
      const currentState = state.productSubCategory

      if (currentState) {
        const list = currentState.list.data
        if (list) {
          return list
        }
        return {}
      }
      return {}
    },
    productSubCategoriesOpt: state => {
      const currentState = state.productSubCategoriesList

      if (currentState) {
        const list = currentState.list.data
        if (Array.isArray(list) && list.length) {
          return list
        }
        return []
      }
      return []
    },
    productSubCategoriesList: state => {
      const currentState = state.productSubCategoriesList

      if (currentState) {
        const list = currentState.list.data
        if (Array.isArray(list) && list.length) {
          return list
        }
        return []
      }
      return []
    },
  },
  mutations: {
    [SET_PRODUCT_SUB_CATEGORIES_LIST](state, val) {
      state.productSubCategoriesList = val
    },
    [SET_PRODUCT_SUB_CATEGORY](state, val) {
      state.productSubCategory = val
    },
  },
  actions: {
    [GET_PRODUCT_SUB_CATEGORIES](context, payload) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}product-subcategory`, payload)
          .then(res => {
            if (res.data.response_code === 2000) {
              // console.log(res.data)
              useJwt.setToken(res.data.token)
              context.commit(SET_PRODUCT_SUB_CATEGORIES_LIST, res.data.data)
              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
    [GET_PRODUCT_SUB_CATEGORY_BY_ID](context, payloadId) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}product-subcategory/${payloadId}`)
          .then(res => {
            if (res.data.response_code === 2000) {
              // console.log(res.data)
              useJwt.setToken(res.data.token)
              context.commit(SET_PRODUCT_SUB_CATEGORY, res.data.data)
              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
    [CREATE_PRODUCT_SUB_CATEGORIES](context, payload) {
      return new Promise((resolve, reject) => {
        axiosIns.post(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}product-subcategory`, payload)
          .then(res => {
            if (res.data.response_code === 2000) {
              // console.log(res.data)
              useJwt.setToken(res.data.token)
              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
    [UPDATE_PRODUCT_SUB_CATEGORIES](context, payload) {
      console.log(payload)
      const { payloadId } = payload
      return new Promise((resolve, reject) => {
        axiosIns.put(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}product-subcategory/${payloadId}`, payload)
          .then(res => {
            if (res.data.response_code === 2000) {
              // console.log(res.data)
              useJwt.setToken(res.data.token)
              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
    [DELETE_PRODUCT_SUB_CATEGORIES](context, payloadId) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}product-subcategory/${payloadId}`)
          .then(res => {
            if (res.data.response_code === 2000) {
              // console.log(res.data)
              useJwt.setToken(res.data.token)
              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
  },
}
